/* global tns */
// eslint-disable-next-line no-unused-vars
/* global Tollwerk */
(function iife(d) {
    // eslint-disable-next-line no-unreachable
    const quotesliders = d.querySelectorAll('.QuoteSlider');
    function disableReadspeakers(thisQuoteSlider) {
        const readspeakers = thisQuoteSlider.querySelectorAll('.Readspeaker');
        const active = thisQuoteSlider.querySelector('.tns-slide-active .Readspeaker');
        readspeakers.forEach((readspeaker) => {
            readspeaker.classList.add('Readspeaker--disabled');
        });
        if (active) {
            active.classList.remove('Readspeaker--disabled');
        }
    }

    quotesliders.forEach((thisQuoteSlider) => {
        const items = thisQuoteSlider.querySelector('.Slider__items');
        const prev = thisQuoteSlider.querySelector('.Slider__control--prev');
        const next = thisQuoteSlider.querySelector('.Slider__control--next');
        const nav = thisQuoteSlider.querySelector('.Slider__nav');

        let doesloop = true;
        if (thisQuoteSlider.getAttribute('data-loop') === 'false') {
            doesloop = false;
        }

        const slider = tns({
            container: items,
            navContainer: nav,
            prevButton: prev,
            nextButton: next,
            items: 1,
            slideBy: 'page',
            touch: true,
            mouseDrag: true,
            swipeAngle: 25,
            preventScrollOnTouch: 'auto',
            autoHeight: thisQuoteSlider.dataset.autoHeight === 'true',
            autoWidth: true,
            rewind: false,
            loop: doesloop,
            edgePanning: 100
        });

        slider.events.on('indexChanged', () => {
            setTimeout(() => {
                disableReadspeakers(thisQuoteSlider);
            }, 0);
        });

        setTimeout(() => {
            disableReadspeakers(thisQuoteSlider);
        }, 1000);
    });
}(document));
